import { mapIntersect } from '../../../util/generic.js';
import ShopEntity from './base.js';
import { showComparerDrawer } from '../../../shop/modules/header-actions-entities/instance-builders/comparer-drawer.js';
import MpDrawer, { OPEN_SELECTOR } from '../../../modules/components/drawer.js';
// import mpro from '../mpro.init';


/**
 * @param {import('../ajax-entities/comparer').MpApiLookupItem[]} items
 * @param {Map<string, import('../ajax-entities/comparer').MpApiLookupItem>=} itemsMap
 */
const serializedMap = (items, itemsMap) => {

	if (!itemsMap) {
		itemsMap = new Map();
	}

	for (const item of items) {

		const orderedItem = {
			product_id: String(item.product_id),
		};

		itemsMap.set(JSON.stringify(orderedItem), orderedItem);
	}

	return itemsMap;
};

export default class Comparer extends ShopEntity {

	/**
	 * @typedef {(resp: import('../ajax-entities/comparer').MpApiLookupResponseData) => void} MpLookupDelayedCallback
	 * @typedef {{ items: import('../ajax-entities/comparer').MpApiLookupItem[], callback: MpLookupDelayedCallback }} MpLookupData
	 */

	static get NAME() {
		return 'Comparer';
	}

	/** @type {MpLookupData[]} */
	queue = [];
	/** @type {number} */
	timer;

	actions = {

		// Use base actions
		...this.actions,

		// Refresh comparer section (counter + tooltip)
		/** @type {import('./base').ShopActionHandler} */
		update_comparer_header: (args, actionType, res, triggerElement) => {
			if (!(res instanceof Error)) {
				const $button = $('[data-toggle-comparer]');
				$button.find('[data-count]').attr('data-count', res.data.count_items || '0');

				if (res.data.count_items > 0) {
					// Show comparer button
					$('[data-toggle-comparer]').closest('.comparer-overlay').removeClass('comparer-overlay--none');
				}
				else {
					// Hide comparer button
					$('[data-toggle-comparer]').closest('.comparer-overlay').addClass('comparer-overlay--none');
				}
			}
		},

		// Show comparer preview in bottom drawer
		/** @type {import('./base').ShopActionHandler} */
		comparer_preview_drawer: (args, actionType, res, triggerElement) => {
			if (!(res instanceof Error)) {
				showComparerDrawer({
					url: mpro.config.routes.compare_preview_drawer,
					relatedTarget: triggerElement,
				}, res);
			}
		},

		// Show comparer preview in bottom drawer
		/** @type {import('./base').ShopActionHandler} */
		comparer_close_empty_preview_drawer: (args, actionType, res, triggerElement) => {
			if (!(res instanceof Error)) {
				if (!(res.data.count_items > 0)) {
					const $alreadyOpen = $(OPEN_SELECTOR).eq(0);
					if ($alreadyOpen.length > 0) {
						MpDrawer.getInstance($alreadyOpen).hide();
					}
				}
			}
		},
	};

	constructor() {
		super();
		// Assign the api
		this.api = mpro.ajax.comparer;
	}

	/**
	 * @param {import('../ajax-entities/comparer').MpApiLookupItem[]} items
	 */
	lookup(items) {
		return this.api.lookup({ items });
	}

	/**
	 * @param {import('../ajax-entities/comparer').MpApiLookupItem[]} items
	 * @param {MpLookupDelayedCallback} callback
	 */
	lookupDelayed(items, callback) {
		this.addLookupToQueue({ items, callback });
	}

	/**
	 * @param {MpLookupData} lookupData
	 */
	addLookupToQueue(lookupData) {
		this.queue.push(lookupData);
		this.timer && window.clearTimeout(this.timer);
		this.timer = window.setTimeout(this.lookupNow.bind(this), 10);
	}

	/**
	 * Reload all queued sections
	 */
	async lookupNow() {

		/** @type {Map<string,import('../ajax-entities/comparer').MpApiLookupItem>} */
		const allItems = new Map();
		const groups = [];

		for (const lookupData of this.queue) {
			groups.push(lookupData);
			serializedMap(lookupData.items, allItems);
		}

		// Reset the queue
		this.queue = [];

		// Do section reload
		const resp = await this.lookup([...allItems.values()]);

		let ErrInvalidResponse;
		const { items } = resp.data;
		const itemsMap = new Map();

		if (!resp || !resp.data?.items) {
			ErrInvalidResponse = new Error('COMPARER_LOOKUP_INVALID_RESPONSE');
		}
		else {
			serializedMap(items, itemsMap);
		}

		for (const group of groups) {
			try {
				// Throw error
				if (ErrInvalidResponse) {
					throw ErrInvalidResponse;
				}

				// Send only the items requested by the group
				const groupItems = [...mapIntersect(itemsMap, serializedMap(group.items)).values()];

				// Call the callback
				group.callback({ ...resp.data, items: groupItems });
			}
			catch {
				continue;
			}
		}
	}

	add(data) {
		return this.api.add(data);
	}

	delete(data) {
		return this.api.delete(data);
	}

	clear() {
		return this.api.clear();
	}
}
